import { Info } from 'lucide-react'

// `<output>` (implicit role="status") rather than an alert: it appears after
// hydration when the geo fetch settles, so a screen reader needs to announce it,
// but it's information, not an error — an alert would interrupt mid-sentence.
// The element is inline by default, so `flex` is doing the layout work here.
export const UsOnlyNotice = () => (
  <output
    data-testid="us-only-notice"
    className="flex items-center gap-2 rounded-2xl bg-white text-secondary-700 px-4 py-3"
  >
    <Info aria-hidden="true" className="size-5 shrink-0 text-blue-500" />
    {/* `<span>`, not `<p>`: `<output>` permits only phrasing content. */}
    <span className="text-balance">Vital Care Finder is currently only supported within the United States.</span>
  </output>
)
